<template>
  <div class="img_container pa-5">
    <!-- <div class="wallet-title">
      <div class="text-h5 font-weight-bold">
        {{ title }}
      </div>
    </div> -->
    <div
      class="d-flex flex-column align-center justify-center"
      style="width:100%;height:100%;overflow:auto;"
    >
      <v-icon size="100" color="info">mdi-hammer-screwdriver</v-icon>
      <!-- <img class="update_img" src="../assets/img/pay_img.png" /> -->
      <div class="d-flex align-center my-3">
        <v-icon color="info">mdi-alert</v-icon>
        <h2 class="info--text">시스템 점검</h2>
      </div>
      <span class="message_caption mb-1">
        안녕하세요, 페이캄입니다.
      </span>
      <span class="message_caption"> 현재 시스템 안정화 및 점검으로 </span>
      <span class="message_caption mb-1">서비스 이용이 제한됩니다. </span>
      <span class="message_caption">
        이용에 불편을 드려 죄송합니다.
      </span>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    title() {
      const name = this.$route.name

      return name.charAt(0).toUpperCase() + name.slice(1)
    }
  },
  created() {
    this.$store.commit('loading', false)
  }
}
</script>

<style lang="scss" scoped>
.img_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  background-color: #f1f2f5;
}
.message_title {
  font-family: roboto;
  font-size: 1.3rem;
  color: #121212;
  text-align: center;
}
.message_caption {
  font-family: roboto;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.3rem;
  color: #121212;
  text-align: center;
}
.top1 {
  margin-top: 2rem;
}
.update_img {
  max-height: 15rem;
  margin-bottom: 1rem;
  max-width: 20rem;
}
</style>
